module.exports = __webpack_public_path__ + "img/result-top.03d5a15b.png";